// --------------------------------------- Project List
export const ProjectList = [
  {
    img: "/IDS.png",
    title: "Intrusion Detection System (IDS)",
    description: "Enhanced with Generative AI, this IDS monitors network traffic and devices to identify and thwart malicious activities effectively.",
    tech_stack: ["Deep Learning", "Docker", "Machine Learning", "Network Security"],
    github_url: "",
    demo_url: "",
  },
  {
    img: "/DOD.png",
    title: "Dual Object Detection using YOLO",
    description: "A project that implements YOLO to detect and differentiate between two distinct objects in real-time.",
    tech_stack: ["Python", "YOLO", "OpenCV", "TensorFlow"],
    github_url: "",
    demo_url: "",
  },
  {
    img: "/HC.png",
    title: "Heartbeat Categorized ",
    description: "A project to develop an ML-based diagnostic tool for categorizing heart diseases through the analysis of heartbeat signals, emphasizing data preprocessing, feature extraction, model development, and deployment .",
    tech_stack: ["Python", "Pandas", "NumPy", "Scikit-learn", "PyTorch", "Jupyter Notebook"],
    github_url: "",
    demo_url: "",
  },
  {
    img: "/ADAS.png",
    title: "Adcanced Driveing Assestent System",
    description: "An Advanced Driving Assistant System (ADAS) leverages machine learning, The system is designed to detect in real-time, providing timely alerts or automated interventions.",
    tech_stack: ["Python", "OpenCV", "TensorFlow", "CNN"],

    github_url: "",
    demo_url: "",
  },
  {
    img: "/DG.png",
    title: "Data Augmentation",
    description: "This project focuses on techniques to expand and diversify datasets, thereby improving model robustness and generalizability, Building on a preliminary feature selection phase, the system applies various augmentation methods—such as SMOT, GAN, CGAN, CTGAN and noise the challenge is to prevent overfitting.",
    tech_stack: ["Python", "SMOT", "Hadoop", "GAN", "Pytorch", "Streamlit"],
    github_url: "",
    demo_url: "",
  },
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
    name: "Python",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/scikitlearn/scikitlearn-original.svg",
    name: "Scikitlearn",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/anaconda/anaconda-original.svg",
    name: "Anaconda",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/tensorflow/tensorflow-original.svg",
    name: "tensorflow",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/atom/atom-original.svg",
    name: "Atom",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original.svg",
    name: "Docker",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
    name: "Git",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/matplotlib/matplotlib-original.svg",
    name: "Matplotlib",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/pytorch/pytorch-original.svg",
    name: "Pytorch",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/streamlit/streamlit-original.svg",
    name: "Streamlit",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
    name: "MongoDB",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/fastapi/fastapi-original.svg",
    name: "Fast-API",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/keras/keras-original.svg",
    name: "Keras",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/kubernetes/kubernetes-original.svg",
    name: "Kubernetes",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
    name: "Java",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/kaggle/kaggle-original.svg",
    name: "Kaggle",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/hadoop/hadoop-original.svg",
    name: "Hadoop",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/github/github-original.svg",
    name: "GitHub",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/figma/figma-original.svg",
    name: "Figma",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/opencv/opencv-original.svg",
    name: "OpenCV",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
    name: "VS Code",
  },
];
